/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import { Route } from '@angular/router';

export const appModals: ReadonlyArray<Route> = [
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CourseConfirmCloseModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-close-modal/course-confirm-close-modal.module'
      ).then(m => m.CourseConfirmCloseModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CourseConfirmDeleteModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-delete-modal/course-confirm-delete-modal.module'
      ).then(m => m.CourseConfirmDeleteModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CourseConfirmPublishModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-publish-modal/course-confirm-publish-modal.module'
      ).then(m => m.CourseConfirmPublishModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CourseConfirmUnpublishModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/academy/instructor/dashboard-page/course-confirm-unpublish-modal/course-confirm-unpublish-modal.module'
      ).then(m => m.CourseConfirmUnpublishModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ContestAwardModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/contests/contest-award-modal/contest-award-modal.module'
      ).then(m => m.ContestAwardModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ContestBuyModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/contests/contest-buy-modal/contest-buy-modal.module').then(
        m => m.ContestBuyModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ContestFilePreviewModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/contests/contest-file-preview-modal/contest-file-preview-modal.module'
      ).then(m => m.ContestFilePreviewModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ContestInterestedFreelancersModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/contests/contest-interested-freelancers-modal/contest-interested-freelancers-modal.module'
      ).then(m => m.ContestInterestedFreelancersModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ContestMakeOfferModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/contests/contest-make-offer-modal/contest-make-offer-modal.module'
      ).then(m => m.ContestMakeOfferModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ContestMultiAwardModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/contests/contest-multi-award-modal/contest-multi-award-modal.module'
      ).then(m => m.ContestMultiAwardModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ContestPollsModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/contests/contest-view/contest-details-tab/contest-polls/contest-polls-modal/contest-polls-modal.module'
      ).then(m => m.ContestPollsModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.QuickviewModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/contests/contest-view/contest-entries-tab/entry-list/quickview-modal/quickview-modal.module'
      ).then(m => m.QuickviewModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CreateCollectionModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/discover-collections/create-collection-modal/create-collection-modal.module'
      ).then(m => m.CreateCollectionModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.DeleteCollectionModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/discover-collections/delete-collection-modal/delete-collection-modal.module'
      ).then(m => m.DeleteCollectionModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.SaveToCollectionModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/discover-collections/save-to-collection-modal/save-to-collection-modal.module'
      ).then(m => m.SaveToCollectionModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.DiscoverManageDeleteModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/discover/discover-manage-portfolio-page/discover-manage-delete-modal/discover-manage-delete-modal.module'
      ).then(m => m.DiscoverManageDeleteModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.DiscoverPublishCancelModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/discover/publish/form/cancel-modal/discover-publish-cancel-modal.module'
      ).then(m => m.DiscoverPublishCancelModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.FileAttachmentsModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/file-attachments-modal/file-attachments-modal.module').then(
        m => m.FileAttachmentsModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i =>
            i.allModalComponents
              .FreelancerOnboardingLinkedAccountsModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/freelancer-onboarding/freelancer-onboarding-linked-accounts-modal/freelancer-onboarding-linked-accounts-modal.module'
      ).then(m => m.FreelancerOnboardingLinkedAccountsModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i =>
            i.allModalComponents.FreelancerVerifiedLandingStatusModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/freelancer-verified/freelancer-verified-landing/freelancer-verified-landing-status-modal/freelancer-verified-landing-status-modal.module'
      ).then(m => m.FreelancerVerifiedLandingStatusModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.GlobalfleetModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/globalfleet/globalfleet-modal/globalfleet-modal.module').then(
        m => m.GlobalfleetModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.GroupConfirmationModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/groups/group-page/group-page-common/group-confirmation-modal/group-confirmation-modal.module'
      ).then(m => m.GroupConfirmationModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.HireMeHourlyConfirmationModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/hire-me/hire-me-hourly-confirmation-modal/hire-me-hourly-confirmation-modal.module'
      ).then(m => m.HireMeHourlyConfirmationModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.HireMePaymentVerifyModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/hire-me/hire-me-payment-verify-modal/hire-me-payment-verify-modal.module'
      ).then(m => m.HireMePaymentVerifyModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.HireMeWebappModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.module'
      ).then(m => m.HireMeWebappModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ArrowOnboardingModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/jobs/job-post/arrow/onboarding-modal/arrow-onboarding-modal.module'
      ).then(m => m.ArrowOnboardingModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ArrowLoginSignupModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/login-signup/arrow-login-signup-modal/arrow-login-signup-modal.module'
      ).then(m => m.ArrowLoginSignupModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.LoginSignupModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/login-signup/login-signup-modal/login-signup-modal.module'
      ).then(m => m.LoginSignupModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ManageFilterModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/manage/shared/manage-top-nav/manage-filter-modal/manage-filter-modal.module'
      ).then(m => m.ManageFilterModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.WorkProjectActionsModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/manage/work/projects/work-project-actions/work-project-actions-modal/work-project-actions-modal.module'
      ).then(m => m.WorkProjectActionsModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.LoadingModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/membership/trial/loading-modal/loading-modal.module').then(
        m => m.LoadingModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.PaymentVerificationNoticeModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/membership/trial/payment-verification-notice-modal/payment-verification-notice-modal.module'
      ).then(m => m.PaymentVerificationNoticeModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.SubscriptionErrorModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/membership/trial/subscription-error-modal/subscription-error-modal.module'
      ).then(m => m.SubscriptionErrorModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.TrialSuccessModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/membership/trial/trial-success-modal/trial-success-modal.module'
      ).then(m => m.TrialSuccessModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CallAlertModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/messaging/messaging-chat/call-alert-modal/call-alert-modal.module'
      ).then(m => m.CallAlertModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.FileViewerModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/messaging/messaging-chat/file-viewer-modal/file-viewer-modal.module'
      ).then(m => m.FileViewerModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.GroupchatManagementModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/messaging/messaging-chat/groupchat-management-modal/groupchat-management-modal.module'
      ).then(m => m.GroupchatManagementModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.PaymentsOverlayComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/payments/common/payments-overlay/payments-overlay.module'
      ).then(m => m.PaymentsOverlayModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.PaymentVerifyModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/payments/payment-verify/payment-verify-modal/payment-verify-modal.module'
      ).then(m => m.PaymentVerifyModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.PaymentsModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/payments/payments-deposit/payments-modal/payments-modal.module'
      ).then(m => m.PaymentsModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.PortfolioItemAttachmentModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/portfolio-item-page/attachment-modal/portfolio-item-attachment-modal.module'
      ).then(m => m.PortfolioItemAttachmentModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.AwardModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/projects/award-modal/award-modal.module').then(
        m => m.AwardModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.BidAwardRevokeModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/bid-award-revoke-modal/bid-award-revoke-modal.module'
      ).then(m => m.BidAwardRevokeModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CloseBiddingModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/close-bidding-modal/close-bidding-modal.module'
      ).then(m => m.CloseBiddingModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.HourlyAwardModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/projects/hourly-award-modal/hourly-award-modal.module').then(
        m => m.HourlyAwardModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.InviteModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/projects/invite-modal/invite-modal.module').then(
        m => m.InviteModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.MarketingMobileNumberModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/marketing-mobile-number-modal/marketing-mobile-number-modal.module'
      ).then(m => m.MarketingMobileNumberModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.MilestoneCancelModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/milestone-cancel-modal/milestone-cancel-modal.module'
      ).then(m => m.MilestoneCancelModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.MilestoneCreateModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/milestone-create-modal/milestone-create-modal.module'
      ).then(m => m.MilestoneCreateModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectDeleteModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-delete-modal/project-delete-modal.module'
      ).then(m => m.ProjectDeleteModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectEndModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/projects/project-end-modal/project-end-modal.module').then(
        m => m.ProjectEndModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectFileRenameModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-files/project-file-rename-modal/project-file-rename-modal.module'
      ).then(m => m.ProjectFileRenameModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectFileShareModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-files/project-file-share-modal/project-file-share-modal.module'
      ).then(m => m.ProjectFileShareModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectFilesPreviewModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-files/project-files-preview-modal/project-files-preview-modal.module'
      ).then(m => m.ProjectFilesPreviewModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CloseProjectModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/close-project-modal/close-project-modal.module'
      ).then(m => m.CloseProjectModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i =>
            i.allModalComponents.DeloitteAdditionalInfoLocationModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-details/deloitte-additional-info/deloitte-additional-info-location-modal/deloitte-additional-info-location-modal.module'
      ).then(m => m.DeloitteAdditionalInfoLocationModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectUpgradeModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-employer/project-upgrades/project-upgrade-modal/project-upgrade-modal.module'
      ).then(m => m.ProjectUpgradeModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectFileFilterModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-files/project-file-filter-modal.compontent/project-file-filter-modal.module'
      ).then(m => m.ProjectFileFilterModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectManagerSidebarModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-payments/employer-payments-area/sidebars/project-manager-sidebar/project-manager-sidebar-modal/project-manager-sidebar-modal.module'
      ).then(m => m.ProjectManagerSidebarModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.DownloadDesktopModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-payments/freelancer-payments-area/download-desktop-modal/download-desktop-modal.module'
      ).then(m => m.DownloadDesktopModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.RejectProjectModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-payments/freelancer-payments-area/reject-project-modal/reject-project-modal.module'
      ).then(m => m.RejectProjectModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.MilestoneReleaseModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-payments/milestone-release-modal/milestone-release-modal.module'
      ).then(m => m.MilestoneReleaseModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectEndBillingModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-payments/project-end-billing-modal/project-end-billing-modal.module'
      ).then(m => m.ProjectEndBillingModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.BidMoreFiltersModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-proposals/bid-list-filtering-wrapper/bid-list-filters/bid-more-filters-modal/bid-more-filters-modal.module'
      ).then(m => m.BidMoreFiltersModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.BidRetractModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-proposals/bid-list/bid-card-new/bid-retract-modal/bid-retract-modal.module'
      ).then(m => m.BidRetractModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.EmployerNewRehireProjectModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-reviews/review-area/employer-new-rehire-project-modal/employer-new-rehire-project-modal.module'
      ).then(m => m.EmployerNewRehireProjectModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProjectCollaborationRevokeModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-share/project-collaboration-revoke-modal/project-collaboration-revoke-modal.module'
      ).then(m => m.ProjectCollaborationRevokeModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.CreateMilestoneFromInvoiceModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-tracking/create-milestone-from-invoice-modal/create-milestone-from-invoice-modal.module'
      ).then(m => m.CreateMilestoneFromInvoiceModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.DeleteTimeTrackingSessionModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/project-view-tracking/freelancer-time-tracking/delete-time-tracking-session-modal/delete-time-tracking-session-modal.module'
      ).then(m => m.DeleteTimeTrackingSessionModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.PunchViewerModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/punch-viewer-modal/punch-viewer-modal.module'
      ).then(m => m.PunchViewerModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.UserPortfolioItemOverlayComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/projects/project-view/user-profile-information/user-portfolio/user-portfolio-item-overlay/user-portfolio-item-overlay.module'
      ).then(m => m.UserPortfolioItemOverlayModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.GiveGetModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/referrals/give-get-modal/give-get-modal.module').then(
        m => m.GiveGetModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.SearchFiltersModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/search/search-filters-modal/search-filters-modal.module'
      ).then(m => m.SearchFiltersModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.SkillsEditModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/skills-edit-modal/skills-edit-modal.module').then(
        m => m.SkillsEditModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.TaskModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/tasks/task-modal/task-modal.module').then(
        m => m.TaskModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.TutorialModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/tutorial/home/tutorial-modal/tutorial-modal.module').then(
        m => m.TutorialModalModule,
      ),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ProfileVerificationsModalComponent,
        ),
    },
    loadChildren: () =>
      import(
        'app/user-profile/user-profile-summary/user-profile-summary-verifications/profile-verifications-modal/profile-verifications-modal.module'
      ).then(m => m.ProfileVerificationsModalModule),
    path: 'hack_not_used',
  },
  {
    data: {
      loadModal: () =>
        import('./app-modal-index').then(
          i => i.allModalComponents.ViolationReportModalComponent,
        ),
    },
    loadChildren: () =>
      import('app/violation-report-modal/violation-report-modal.module').then(
        m => m.ViolationReportModalModule,
      ),
    path: 'hack_not_used',
  },
];
